import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex h-[95vh] h-auto max-h-[90vh] w-[95vw] max-w-content flex-col space-y-4 rounded-3xl bg-white p-10" }
const _hoisted_2 = { class: "flex w-full justify-between" }
const _hoisted_3 = { class: "grow space-y-6 overflow-scroll" }
const _hoisted_4 = { class: "absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 text-viridian-500" }

import { ref, onMounted } from "vue";

import { getGlobalTranslation } from "~/js/composables/translations";
import { blockSmoother, resetSmoother } from "~/js/composables/smoother";

import TextH3 from "~/vue/atoms/texts/TextH3.vue";
import ButtonSecondary from "~/vue/atoms/buttons/ButtonSecondary.vue";
import FormHubspot from "~/vue/organisms/forms/FormHubspot.vue";
import SvgLoader from "~/vue/atoms/svgs/SvgLoader.vue";

interface Props {
	portalId: string;
	formId: string;
	prePopulatedFields?: any;
	utilities?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PopupHubspot',
  props: {
    portalId: {},
    formId: {},
    prePopulatedFields: {},
    utilities: { default: "" }
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;
const popup = ref(null);

const onClose = () => {
	emit("close");
	resetSmoother();
};

onMounted(() => {
	window.addEventListener("load", () => {
		blockSmoother();
	});

	blockSmoother();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "popup",
    ref: popup,
    class: "fixed left-0 top-0 z-[1000] !mt-0 flex h-full w-full items-center justify-center bg-black/50"
  }, [
    _createElementVNode("article", _hoisted_1, [
      _createElementVNode("header", _hoisted_2, [
        _createElementVNode("h1", null, [
          _createVNode(TextH3, { color: "text-orange-500" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(getGlobalTranslation)("Contact")), 1)
            ]),
            _: 1
          })
        ]),
        _createVNode(ButtonSecondary, {
          type: "button",
          size: "small",
          icon: "times",
          ga: {
						category: 'form',
						action: 'close',
						label: __props.portalId,
					},
          onClick: onClose
        }, null, 8, ["ga"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(FormHubspot, {
          "portal-id": __props.portalId,
          "form-id": __props.formId,
          "pre-populated-fields": __props.prePopulatedFields,
          utilities: "bg-white z-10 relative"
        }, null, 8, ["portal-id", "form-id", "pre-populated-fields"]),
        _createElementVNode("span", _hoisted_4, [
          _createVNode(SvgLoader)
        ])
      ])
    ])
  ], 512))
}
}

})